import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getFile, shareFile } from "../../../actions";
import { BackButtonIcon } from "../../../constants/icons";
import { toaster } from "../../../function";
import { ToastsStore } from "react-toasts";
import DownloadButton from "../../Buttons/DownloadButton";
import EmailButton from "../../Buttons/EmailButton";
import BomIssuesButton from "../../Buttons/BomIssuesButton";
import { getIssueCountBadge } from "../../../constants/issueReportUtils";
import {
  buildHistoryExportPayload,
  downloadOriginalAndResultBomFiles,
  exportStructuredBomExcel,
} from "../../../utils/historyBomExport";

const BomPageTitle = (props) => {
  const [fileName, setFileName] = useState("");
  const [downloadMailEnabled, setDownloadMailEnabled] = useState(false);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (props?.bomDetails?.data) {
      setFileName(props.bomDetails?.data.file_name);
      setDownloadMailEnabled(true);
    }
  }, [props.bomDetails]);

  const buildExportPayload = (exportLocally = true) =>
    buildHistoryExportPayload({
      user: props.user,
      bomRow: {
        id: props.bomDetails?.data?.id,
        file_name: props.bomDetails?.data?.file_name,
      },
      bomDetails: props.bomDetails,
      structuredBomlines: props.structuredBomlines,
      columns: props.columns,
      issueReport: props.issueReport,
      freightTotal: props.freightTotal,
      tariffTotal: props.tariffTotal,
      exportLocally,
    });

  const downloadFile = async () => {
    if (exporting) {
      return;
    }

    setExporting(true);
    try {
      const exportPayload = buildExportPayload(true);
      await downloadOriginalAndResultBomFiles({
        user: props.user,
        getFile: props.getFile,
        filePath: props.bomDetails?.data?.file_path,
        fileName: props.bomDetails?.data?.file_name,
        resultFilePath: null,
        exportResult: exportPayload.structuredBomlines?.length
          ? exportPayload
          : null,
      });
    } catch (error) {
      toaster(ToastsStore, "error", "Could not export the BOM file.");
    } finally {
      setExporting(false);
    }
  };

  const emailFile = async () => {
    if (exporting) {
      return;
    }

    setExporting(true);
    try {
      if (props.structuredBomlines?.length) {
        await exportStructuredBomExcel(buildExportPayload(false));
      }

      let data = await props.shareFile(
        props.user.token,
        props.bomDetails?.data?.result_file_path,
        "Result-" + props.bomDetails?.data?.file_name + ".xlsx"
      );
      if (data.status >= 200 && data.status < 400) {
        toaster(
          ToastsStore,
          "success",
          "Sent the BOM file to your registered email."
        );
      } else {
        data = await props.shareFile(
          props.user.token,
          props.bomDetails?.data?.file_path,
          props.bomDetails?.data?.file_name + ".xlsx"
        );
        if (data.status >= 200 && data.status < 400) {
          toaster(
            ToastsStore,
            "success",
            "Sent the BOM file to your registered email."
          );
        } else if (data.status === 404) {
          toaster(ToastsStore, "error", "Could not find the file.");
        } else {
          toaster(ToastsStore, "error", "Could not get the file.");
        }
      }
    } catch (error) {
      toaster(ToastsStore, "error", "Could not export the BOM file.");
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="bomPageTitle">
      <a href="/history">
        <BackButtonIcon className="icon" />
      </a>
      <div className="bomName">
        <div className="bomNameTitle">BOM File Name</div>
        <div className="bomNameNameRow">
          <div className="bomNameName">{fileName}</div>
          {props.onOpenIssueReport && (
            <BomIssuesButton
              className="bomPageIssuesBtn"
              badgeCount={getIssueCountBadge(props.issueReport)}
              onClick={props.onOpenIssueReport}
            />
          )}
        </div>
      </div>
      {downloadMailEnabled ? (
        <React.Fragment>
          <DownloadButton
            className="linkBtn download"
            onClick={() => downloadFile()}
          />
          <EmailButton className="linkBtn email" onClick={() => emailFile()} />
        </React.Fragment>
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, { getFile, shareFile })(BomPageTitle);
